import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-asset",
  "use": "icon-asset-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-asset\">\n    <path fill=\"#fff\" d=\"M397.2 289.6h217c67.2 0 118.7-144.6 118.7-144.6 0-43.4-4.2-75.9-79.1-78.5-74.4-2.6-92.7 51.6-146.3 51.6-55.2 0-82.3-42.3-150-51.6s-79.1 35.1-79.1 78.5c0 0 51.5 144.6 118.7 144.6h0.1z m229.1 44.9h-229c-253.5 0-316 494.1-316 494.1 0 65.1 53.1 130.1 118.7 130.1h624.1c65.6 0 118.7-65.1 118.7-130.1-0.6 0-63-494.1-316.5-494.1z m26 380c15.1-0.4 27.7 11.6 28 26.7 0.4 15.1-11.6 27.7-26.7 28H539.9v72.3c-0.4 15.2-13 27.3-28.3 26.9-14.7-0.4-26.6-12.2-26.9-26.9v-72.3h-113c-15.1 0.4-27.7-11.6-28-26.7-0.4-15.1 11.6-27.7 26.7-28h114.2v-34.6H371.7c-15.1 0.4-27.7-11.6-28-26.7-0.4-15.1 11.6-27.7 26.7-28h77.8l-78.6-138.4c-7.6-13.1-3.2-30 9.9-37.7 13.2-7.6 30.1-3.2 38 9.8l94.2 165.2h4.7l94.2-165.2c7.9-13.1 24.8-17.5 38-9.8 13.1 7.6 17.6 24.5 9.9 37.6v0.1l-78.1 137.9h71.8c15.1-0.4 27.7 11.6 28 26.7 0.4 15.1-11.6 27.7-26.7 28H539.8V714h112.4l0.1 0.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/asset.svg
// module id = S8k9
// module chunks = 178